module.exports = __webpack_public_path__ + "static/media/alles_richtig.8d3a4811.jpg";